(function Module() {
	'use strict';

	mySynch.controller('HerdCostsController', [
		'$scope',
		'$location',
		'MySynchFactory',
		'ApiFactory',
		'clientLoggerService',
		function HerdCostsController($s, $location, MSF, api, log) {
			function updateInputsWithActiveHerdData() {
				var allInputFields = [
					'laborCostPerCow',
					'professionalServicesCostPerCow',
					'semenCostPerCow',
					'feedCostLactatingPerPound',
					'feedCostDryPerPound',
					'heiferReplacementValuePerCow',
					'pgCostPerDose',
					'pgProductTypeId',
					'gnRHCostPerDose',
					'gnRHProductTypeId',
					'cIDRCostPerDose',
					'milkPricePerCwt',
					'premiumMilkPerPound',
					'maleCalfPrice',
					'femaleCalfPrice',
					'cullCowPrice',
					'otherRevenue',
					'modifiedOn'
				];
				$s.inputs = _.pick(MSF.getActiveHerd(), allInputFields);
			}

			function loadHerdFromDb() {
				$s.loading = true;

				api.getHerd(MSF.getActiveHerd().herdId, function herdGotten(err, herd) {
					$s.loading = false;

					if (err) {
						log.error('error getting herd: ' + err);
					}

					MSF.setActiveHerd(herd);
					updateInputsWithActiveHerdData();
				});
			}

			function routeChange(event, newUrl, oldUrl) {
				if (event.currentScope.farmDetailsCtrl.costForm.$pristine) {
					return;
				}

				MSF.confirm('unsavedChanges', function confirmed() {
					onRouteChangeOff(); // this deregisters the listener
					$location.path($location.url(newUrl).hash());
					$s.$apply();
				});

				event.preventDefault();

				return;
			}

			// $on returns a deregistration function for itself
			var onRouteChangeOff = $s.$on('$locationChangeStart', routeChange);

			$s.$on('herd:changed', updateInputsWithActiveHerdData);

			$s.inputs	= {};
			$s.MSF		= MSF;

			$s.pgfHormoneTypeId		= 1;
			$s.gnrhHormoneTypeId	= 2;

			$s.loading	= false;
			$s.saving	= false;

			$s.saveCosts = function saveCosts() {
				$s.saving = true;

				api.updateHerd(_.extend({}, MSF.getActiveHerd(), $s.inputs), function herdUpdate(err) {
					$s.saving = false;

					if (err) {
						log.error(err);
						MSF.notify.danger('Error occurred trying to save farm: ' + err);

						return false;
					}

					MSF.notify.success('Changes saved successfully');
				});
			};

			MSF.ready(function whenMsfReady() {
				updateInputsWithActiveHerdData();
				loadHerdFromDb();
			});
		}
	]);
})();
